var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.field.type === "file" && _vm.value.value && _vm.value.value.url
        ? [
            _c(
              "v-btn",
              {
                staticClass: "truncate-sub-text",
                attrs: { text: "", "max-width": "100%", height: "33px" },
                nativeOn: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.imgDialog = true
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.getValue(_vm.field, _vm.value)) +
                    "\n\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { width: "500" },
                model: {
                  value: _vm.imgDialog,
                  callback: function($$v) {
                    _vm.imgDialog = $$v
                  },
                  expression: "imgDialog"
                }
              },
              [
                _c(
                  "v-card",
                  [
                    _vm.value.value
                      ? _c("v-img", { attrs: { src: _vm.value.value.url } })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]
        : [
            _vm._v(
              "\n\t\t" + _vm._s(_vm.getValue(_vm.field, _vm.value)) + "\n\t"
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45599166", { render: render, staticRenderFns: staticRenderFns })
  }
}